import {put, call, takeLatest} from 'redux-saga/effects';
import invoiceRegistrationApi from '../api/invoiceRegistration.api';
import * as ActionTypes from '../actions/types.action';
import {HTTP_STATUS} from '../constants/constants';

// The global interceptor (helpers/api.helper.js) rejects a 500 with just the
// parsed body, stripping the {status, data} wrapper it otherwise leaves alone
// for every other status — normalise both shapes here so this saga only ever
// deals with one.
const normalizeErrorResponse = e => {
  if (e && e.response) {
    return {status: e.response.status, data: e.response.data};
  }
  return {status: HTTP_STATUS.SERVER_ERROR, data: e};
};

// See self-serve-signup.pdf for the full error table this mirrors. 404 and
// 422 both mean the processId can no longer be turned into a signup (it
// doesn't exist, or the invoice behind it was never usable) — either way the
// visitor needs a fresh upload rather than a retry of this same submission.
function* submitInvoiceRegistration(action) {
  try {
    const response = yield call(
      invoiceRegistrationApi.submitFromInvoice,
      action.processId,
      action.customerEmail,
      action.customerMobile
    );
    yield put({
      type: ActionTypes.SUBMIT_INVOICE_REGISTRATION_SUCCESS,
      response,
    });
  } catch (e) {
    const {status, data} = normalizeErrorResponse(e);
    if (status === HTTP_STATUS.NOT_FOUND) {
      yield put({
        type: ActionTypes.SUBMIT_INVOICE_REGISTRATION_FAILED,
        error: "We couldn't find that comparison.",
        needsNewUpload: true,
      });
      return;
    }
    if (status === HTTP_STATUS.UNPROCESSABLE) {
      yield put({
        type: ActionTypes.SUBMIT_INVOICE_REGISTRATION_FAILED,
        error:
          (data && data.message) ||
          "We couldn't read an invoice from your upload.",
        needsNewUpload: true,
      });
      return;
    }
    if (status === HTTP_STATUS.CONFLICT) {
      yield put({
        type: ActionTypes.SUBMIT_INVOICE_REGISTRATION_FAILED,
        error:
          (data && data.message) ||
          "We're still reading your invoice — please try again in a moment.",
      });
      return;
    }
    if (status === HTTP_STATUS.SERVICE_UNAVAILABLE) {
      yield put({
        type: ActionTypes.SUBMIT_INVOICE_REGISTRATION_FAILED,
        error:
          'Registration is temporarily unavailable. Please try again later.',
      });
      return;
    }
    yield put({
      type: ActionTypes.SUBMIT_INVOICE_REGISTRATION_FAILED,
      error:
        (data && data.message) || 'Something went wrong. Please try again.',
    });
  }
}

export default function* invoiceRegistrationSaga() {
  yield takeLatest(
    ActionTypes.SUBMIT_INVOICE_REGISTRATION_REQUESTED,
    submitInvoiceRegistration
  );
}
